module.exports = __webpack_public_path__ + "img/2025_1.ef4659f3.webp";